module.exports = __webpack_public_path__ + "static/media/pavilions.1592e01c.svg";